import React from "react";
import "../Hero.css";

function Hero() {
  return (
    <section className="hero">

      {/* LEFT CONTENT */}
      <div className="hero-left">
        <p className="tagline">Smart Learning Platform</p>

        <h1>
          Learn From Anywhere <br />
          <span>Build Your Future</span>
        </h1>

        <p className="description">
          Upgrade your skills with interactive online courses designed
          to help you grow faster and smarter — from the comfort of your home.
        </p>

        <div className="buttons">
          <button className="primary-btn">Get Started</button>
          {/* <button className="secondary-btn">Explore Courses</button> */}
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="hero-right">
        <div className="image-wrapper">
          <img src="/images/11.webp" alt="E-learning" />
        </div>
      </div>

    </section>
  );
}

export default Hero;
